import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, InputNumber, Select, Spin } from "antd";
import { AiOutlineArrowRight } from "react-icons/ai";
import axios from "axios";
import { useDispatch } from "react-redux";
import { changeHeader } from "../../../redux/reducer/headerSlice";
import { BASE_URL } from "../../../utils/config";
import handleGet from "../../../utils/Get";
import handlePost from "../../../utils/Post";
import { useTranslation } from "react-i18next";
import { HiShieldCheck } from "react-icons/hi2";

const UserDashboard = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    welcomeback,
    chart,
    Assets,
    price,
    view,
    all,
    Swap,
    Latest,
    Transactions,
    The,
    Trade,
    Market,
    start,
    kyc,
    BTC,
    Overview,
    my,
    net,
    worth,
    exchange,
    crypto,
    select,
    from,
    asset,
    enter,
    network,
    fe,
    no,
    of,
    coins,
    total,
    For,
    ETH,
    verify,
    your,
    identify,
    enhanced,
    security,
    account,
    is,
    not,
    you,
    can,
    only,
    use,
    the,
    basic,
    features,
    please,
  } = t("dashboard", { returnObjects: true });

  const [assets, setAssets] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [netWorth, setNetWorth] = useState({ value: "", loading: true });
  const [userNote, setNote] = useState({ value: "", loading: true });
  const [graphData, setGraphData] = useState([]);
  const [graphData2, setGraphData2] = useState([]);
  const [fromAsset, setFromAsset] = useState("");
  const [toAsset, setToAsset] = useState("");
  const [amount, setAmount] = useState(null);
  const [exchangeData, setExchangeData] = useState("");
  const [loading, setLoading] = useState(false);
  const [swapping, setSwapping] = useState(false);
  const [loader, setLoader] = useState(false);
  const [currencyOpen, setCurrencyOpen] = useState(false);
  const [currency, setCurrency] = useState("USD");

  const fetchAssets = async () => {
    setLoading(true);
    try {
      const response = await handleGet(`${BASE_URL}active/user/assets`);
      setAssets(response?.assets || []);
    } catch (error) {
      console.error("Error fetching assets:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTransaction = async () => {
    const data = await handleGet(`${BASE_URL}active/user/transaction`);
    setTransactions(data?.transactions || []);
  };

  const fetchGraphData = async (coin = "bitcoin") => {
    try {
      const response = await axios.get(
        `https://api.coingecko.com/api/v3/coins/${coin}/market_chart?vs_currency=usd&days=120&interval=daily`
      );
      return response?.data?.prices || [];
    } catch (error) {
      console.error(error.message);
      return [];
    }
  };

  const fetchNetWorth = async () => {
    try {
      const data = await handleGet(`${BASE_URL}get/user/networth`);
      setNetWorth({ value: data?.networth, loading: false });
      setNote({ value: data?.userNote, loading: false });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dispatch(changeHeader(`${user.name}, ${welcomeback}`));
    fetchNetWorth();
    fetchAssets();
    fetchTransaction();
    fetchGraphData("bitcoin").then(setGraphData);
    fetchGraphData("ethereum").then(setGraphData2);
  }, []);

  const handleNavigate = (value) => navigate("/user/wallet/manage", { state: value });

  const handleExchange = async (amt, from, to) => {
    if (!amt || !from || !to) return;
    setLoader(true);
    try {
      const response = await handlePost(`${BASE_URL}currencyexchange/onchange`, {
        amount: amt,
        from_asset_id: from,
        to_asset_id: to,
      });
      if (response) setExchangeData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const submitSwap = async () => {
    setSwapping(true);
    try {
      await handlePost(`${BASE_URL}currency/exchange`, {
        amount,
        from_asset_id: fromAsset,
        to_asset_id: toAsset,
      });
      fetchNetWorth();
      fetchAssets();
      fetchTransaction();
      setFromAsset("");
      setToAsset("");
      setAmount(null);
      setExchangeData("");
    } catch (error) {
      console.error(error);
    } finally {
      setSwapping(false);
    }
  };

  return (
    <section className="space-y-6 text-[15px]">

      {/* ── Row 1: Net Worth Card + KYC ── */}
      <div className="grid gap-5 lg:grid-cols-2">

        {/* Net Worth Card */}
        <div className="relative rounded-[30px] bg-gradient-to-br from-[#7b5cff] to-[#5b3df5] p-7 text-white shadow-[0_40px_90px_rgba(0,0,0,0.7)]">
          <div className="flex justify-between items-start">
            <div className="px-3 py-3">
              <p className="text-xs tracking-[0.25em] uppercase text-indigo-100">
                {my} {net} {worth}
              </p>
              {netWorth.loading ? (
                <div className="h-14 w-40 bg-white/10 animate-pulse rounded-xl mt-2" />
              ) : (
                <h2 className="text-[52px] font-semibold mt-2 leading-none">
                  ${Number(netWorth.value).toLocaleString()}
                </h2>
              )}
              {!userNote.loading && userNote.value && (
                <p className="text-emerald-300 text-sm mt-1">{userNote.value}</p>
              )}
            </div>


          </div>

          <div className="h-px bg-white/20 my-4" />

          {/* Quick actions */}
          <div className="grid grid-cols-3 items-center">
            <Link to={'/user/wallet'} onClick={() => {
              window.scrollBy({
                top: 500,
                behavior: "smooth",
              });
            }} className="flex flex-col items-center gap-2">
              <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-[#0e1629] text-xl shadow-[0_18px_40px_rgba(15,23,42,0.75)]">
                →
              </span>
              <span className="text-sm font-semibold text-indigo-50">Send</span>
            </Link>
            <Link to={'/user/swapcrypto'} className="flex flex-col items-center gap-2">
              <span className="inline-flex h-16 w-16 -translate-y-1 items-center justify-center rounded-2xl bg-white text-xl text-[#6d4cf7] shadow-[0_18px_40px_rgba(15,23,42,0.75)]">
                ⇄
              </span>
              <span className="text-sm font-semibold text-indigo-50">{Swap}</span>
            </Link>
            <Link to={'/user/wallet'} onClick={() => {
              window.scrollBy({
                top: 500,
                behavior: "smooth",
              });
            }} className="flex flex-col items-center gap-2">
              <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-[#0e1629] text-xl shadow-[0_18px_40px_rgba(15,23,42,0.75)]">
                ↓
              </span>
              <span className="text-sm font-semibold text-indigo-50">Withdraw</span>
            </Link>
          </div>
        </div>

        {/* KYC Section */}
        {user?.active_status !== "approved" ? (
          <div className="flex h-full flex-col justify-between rounded-[26px]  bg-[#1e293b] px-3 py-3 text-slate-100 shadow-[0_22px_60px_rgba(15,23,42,0.9)]">
            <div className="flex items-start gap-3">
              <HiShieldCheck className="text-emerald-500 text-2xl mt-1" />

              <div>
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-400">
                  KYC verification
                </p>

                <p className="mt-1 text-base font-semibold text-slate-50">
                  {verify} {your} {identify} {For} {enhanced} {security}
                </p>

                <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                  {your} {account} {is} {not} {verify}, {please} {verify} {your} {account}.
                </p>
              </div>
            </div>
            <div className="mt-6">
              <Link to="/verification" className="block w-full">
                <button className="w-full inline-flex items-center justify-center rounded-full bg-[#6e48ff] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_18px_40px_rgba(15,23,42,0.65)] transition hover:bg-[#7a5cff]">
                  {start} {kyc} →
                </button>
              </Link>
              <p className="mt-3 text-center text-xs text-slate-500">Takes less than 2 minutes.</p>
            </div>
          </div>
        ) : (
          /* If KYC approved, show a placeholder stats card */
          <div className="flex flex-col justify-center rounded-[26px]  bg-[#1e293b] px-3 py-3 text-slate-100 shadow-[0_22px_60px_rgba(15,23,42,0.9)]">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-400">Account</p>
            <p className="mt-1 text-base font-semibold text-slate-50">Identity Verified</p>
            <div className="mt-3 inline-flex items-center gap-2 text-emerald-400 text-sm font-medium">
              <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
              All features unlocked
            </div>
          </div>
        )}
      </div>



      {/* ── Row 3: Assets Overview + Swap ── */}
      <div className="grid gap-5 lg:grid-cols-2">

        {/* Assets Overview */}
        <div className="rounded-[26px]  bg-[#1e293b] px-3 py-3 shadow-[0_22px_60px_rgba(15,23,42,0.9)]">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">{Assets}</p>
          <p className="mt-1 text-base font-semibold text-slate-200">{Overview}</p>

          <div className="mt-4 space-y-2.5 max-h-[300px] overflow-y-auto pr-1">
            {loading ? (
              <div className="flex items-center justify-center py-10">
                <div className="h-6 w-6 rounded-full border-2 border-emerald-400 border-t-transparent animate-spin" />
              </div>
            ) : assets.length > 0 ? (
              assets.slice(0, 6).map((item) => (
                <div
                  key={item.id}
                  className="flex items-center justify-between gap-3 rounded-2xl  bg-slate-950/90 px-4 py-3.5 text-sm hover:border-slate-700 transition"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-dark text-white border-[0.5px] border-opacity-60 border-gray-400 rounded-full flex justify-center items-center">
                      <img
                        className="w-8 h-8 filter-class"
                        src={item?.symbol}
                        alt={item?.symbol}
                      />
                    </div>
                    <div>
                      <p className="text-base font-semibold text-slate-100">{item?.name}</p>
                      <p className="text-sm text-slate-500">
                        {item?.amount} {item?.short_name}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => handleNavigate(item)}
                    className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#6e48ff] text-white hover:bg-[#7a5cff] transition shadow-[0_8px_20px_rgba(110,72,255,0.35)]"
                  >
                    <AiOutlineArrowRight size={16} />
                  </button>
                </div>
              ))
            ) : (
              <div className="flex h-full items-center justify-center text-sm text-slate-500 py-10">
                No assets found.
              </div>
            )}
          </div>
        </div>

        <div className="max-w-md mx-auto rounded-3xl bg-[#1e293b] px-3 py-3 shadow-2xl">
          <h2 className="text-white text-lg font-semibold mb-3 flex items-center gap-2">
            ⇅ {Swap}
          </h2>

          {/* SEND */}
          <div className="bg-[#efe4c9] rounded-2xl p-4">
            <p className="text-xs font-semibold uppercase tracking-widest text-stone-500 mb-2">Send</p>
            <div className="flex items-center gap-3">
              <input
                type="number"
                placeholder="0.00"
                value={amount ?? ""}
                onChange={(e) => {
                  const val = e.target.value ? Number(e.target.value) : null;
                  setAmount(val);
                  handleExchange(val, fromAsset, toAsset);
                }}
                className="flex-1 min-w-0 bg-transparent border-none outline-none text-3xl font-semibold text-stone-800 placeholder-stone-400 w-full"
                style={{ appearance: "textfield" }}
              />
              <div className="relative">
                <select
                  value={fromAsset}
                  onChange={(e) => {
                    setFromAsset(e.target.value);
                    handleExchange(amount, e.target.value, toAsset);
                  }}
                  className="appearance-none bg-[#1e293b] text-slate-100 font-semibold text-sm rounded-xl pl-3 pr-8 py-2 border-none outline-none cursor-pointer min-w-[100px]"
                >
                  <option value="">Select</option>
                  {assets.map(a => (
                    <option key={a.id} value={a.id}>{a.name}</option>
                  ))}
                </select>
                <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 text-xs">▾</span>
              </div>
            </div>
          </div>

          {/* DIVIDER BUTTON */}
          <div className="flex justify-center -my-3.5 relative">
            <button className="h-11 w-11 rounded-full bg-[#0f172a] border-2 border-slate-700 flex items-center justify-center text-white text-lg shadow-lg hover:rotate-180 transition-transform duration-300">
              ⇅
            </button>
          </div>

          {/* RECEIVE */}
          <div className="bg-[#cfe3df] rounded-2xl p-4 mt-1">
            <p className="text-xs font-semibold uppercase tracking-widest text-teal-700 mb-2">Receive</p>
            <div className="flex items-center gap-3">
              <input
                type="number"
                placeholder="0.00"
                value={exchangeData || ""}
                readOnly
                className="flex-1 min-w-0 bg-transparent border-none outline-none text-3xl font-semibold text-teal-900 placeholder-teal-400 w-full cursor-default"
                style={{ appearance: "textfield" }}
              />
              <div className="relative">
                <select
                  value={toAsset}
                  onChange={(e) => {
                    setToAsset(e.target.value);
                    handleExchange(amount, fromAsset, e.target.value);
                  }}
                  className="appearance-none bg-[#1e293b] text-slate-100 font-semibold text-sm rounded-xl pl-3 pr-8 py-2 border-none outline-none cursor-pointer min-w-[100px]"
                >
                  <option value="">Select</option>
                  {assets.filter(a => a.id !== fromAsset).map(a => (
                    <option key={a.id} value={a.id}>{a.name}</option>
                  ))}
                </select>
                <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 text-xs">▾</span>
              </div>
            </div>
          </div>

          {/* SWAP BUTTON */}
          <button
            onClick={submitSwap}
            disabled={swapping || !fromAsset || !toAsset || !amount}
            className="mt-5 w-full py-3.5 rounded-2xl text-white font-bold text-base
      bg-gradient-to-r from-[#734aff] to-[#5b34ea] hover:opacity-90 transition
      disabled:opacity-50 disabled:cursor-not-allowed shadow-[0_8px_30px_rgba(110,72,255,0.4)]"
          >
            {swapping ? "Swapping..." : "Swap Now"}
          </button>
        </div>

      </div>

      {/* ── Row 4: Latest Transactions ── */}
      <div className="rounded-[26px]  bg-[#1e293b] px-3 py-3 shadow-[0_22px_60px_rgba(15,23,42,0.9)]">
        <div className="flex justify-between items-center mb-4">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">{Transactions}</p>
            <p className="mt-1 text-base font-semibold text-slate-200">{Latest} {Transactions}</p>
          </div>
          <Link to="/user/transaction">
            <button className="inline-flex items-center gap-1.5 rounded-full border border-slate-700 bg-slate-900/60 px-4 py-2 text-xs font-semibold text-slate-300 hover:border-slate-600 hover:text-slate-100 transition">
              {view} {all} <AiOutlineArrowRight size={13} />
            </button>
          </Link>
        </div>

        <div className="rounded-2xl border border-dashed border-slate-800/80 bg-slate-950/60 overflow-hidden">
          {transactions.length > 0 ? (
            <div className="divide-y divide-slate-800/60">
              {transactions.slice(0, 3).map((item) => (
                <div
                  key={item.id}
                  className="flex items-center justify-between px-4 py-3.5 text-sm hover:bg-slate-800/30 transition"
                >
                  <div className="flex items-center gap-3">
                    <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-slate-800">
                      {item.asset?.symbol ? (
                        <img
                          src={item.asset?.symbol}
                          alt={item.asset?.name}
                          className="h-6 w-6 object-contain"
                          style={{ filter: "invert(1)" }}
                        />
                      ) : (
                        <span className="text-slate-300 text-xs font-bold uppercase">
                          {item.asset?.name?.[0] ?? "?"}
                        </span>
                      )}
                    </div>
                    <div>
                      <p className="font-semibold text-slate-200">{item.asset?.name}</p>
                      <p className="text-xs text-slate-500 capitalize">
                        {item.status}
                      </p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-semibold text-slate-100">{item.amount}</p>
                    <p
                      className={`text-xs capitalize ${item.status === "confirmed"
                        ? "text-emerald-400"
                        : item.status === "processing"
                          ? "text-yellow-400"
                          : "text-red-400"
                        }`}
                    >
                      {item.status}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center px-6 py-10 text-center text-sm text-slate-500">
              <p className="text-base font-semibold text-slate-200">No recent transactions yet</p>
              <p className="mt-2 max-w-sm">New activity will appear here once you start using your wallet.</p>
            </div>
          )}
        </div>
      </div>

    </section>
  );
};

export default UserDashboard;